export const USER_STATUS = {
  HASRENTALS: "has_rentals",
  NORENTALS: "no_rentals",
  UNCONFIRMED: "unconfirmed",
};
